import { ReactNode } from 'react';
import { DeleteButton } from '../DeleteButton/DeleteButton';

type DeleteColumnProps = {
  disabled: boolean;
  disabledMessage: ReactNode;
  onClick: () => void;
  className?: string;
};

export const DeleteColumn = ({
  disabled,
  disabledMessage,
  onClick,
  className,
}: DeleteColumnProps) => {
  return (
    <DeleteButton
      onClick={onClick}
      disabled={disabled}
      tooltip={disabledMessage}
      className={className}
    />
  );
};
